import { Deal } from '../resources/deal';
import { DealsBag } from '../resources/deals-bag';

export class BuildingDealAmountsBalanceHelper {
    public dealsBag: DealsBag = new DealsBag();

    public calculateDiscountAmount(): number {
        let sum: number = 0;
        this.dealsBag.relationships.deals.data.forEach((deal: Deal) => {
            const discountAmount: number = deal.attributes.rest_to_pay * (deal.attributes.gain_percent / 100);
            sum += discountAmount;
        });

        return sum;
    }
}
